import AgendaHeader from './AgendaHeader';

export default AgendaHeader;